/*** IMPORTS FROM imports-loader ***/
var define = false;

jQuery(document).ready(function($) {

	$( ".service-pill" ).first().addClass( "active" );
	$( ".service-pane" ).first().addClass( "active" );

	$('.sub').prev('h1', 'h2', 'h3', 'h4', 'h5', 'h6').addClass('mb-0');

  $('.image-slider').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    prevArrow:"<i class='fa fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fa fa-angle-right slick-next'></i>",
  });

  $('.header-slider').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    prevArrow:"<i class='fa fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fa fa-angle-right slick-next'></i>",
  });


  //quote slider
  $('.slider-quote').slick({
	  centerMode: true,
		centerPadding: '0',
	  slidesToShow: 1,
		arrows: true,
		dots: true,
		infinite: true,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 1
	      }
	    }
	  ]
	});

  $('.slider-testimonial').slick({
	  centerMode: true,
		centerPadding: '0',
	  slidesToShow: 3,
		arrows: true,
		infinite: true,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 1
	      }
	    }
	  ]
	});

  $('.slider-history').slick({
	  centerMode: true,
		centerPadding: '0',
	  slidesToShow: 3,
		arrows: true,
		infinite: true,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '0',
	        slidesToShow: 1
	      }
	    }
	  ]
	});

  //change accordion icon
  $('.collapse')
    .on('shown.bs.collapse', function() {
      $(this)
        .parent()
        .find(".fa-angle-down")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-up");
    })
    .on('hidden.bs.collapse', function() {
      $(this)
        .parent()
        .find(".fa-angle-up")
        .removeClass("fa-angle-up")
        .addClass("fa-angle-down");
    });



  //slick slider
  $('.history-slider').slick({
    centerMode: true,
    centerPadding: '',
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    draggable: true,
    arrows: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
  });

  //add slide-next button
  $('.hs-next').click(function(){
    $('.history-slider').slick('slickNext');
  });

});

